import React from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Icon } from '../../shared/Icons';

interface NavigationMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  items: Array<{
    title: string;
    path: string;
    iconName: string;
  }>;
  isActive: (path: string) => boolean;
  track?: (action: string, eventName: string, eventType: string, data?: any, extractorType?: string, priority?: string) => void;
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ anchorEl, open, onClose, items, isActive, track }) => {
  const theme = useTheme();
  const handleSubmenuClick = (item: any) => {
    if (track && item.path) {
      track(
        'navigation_click',
        'click',
        'NavigationSubmenuClick',
        {
          navigationPath: item.path,
          menu: item.title
        },
        'raw',
        '2'
      );
    }
  };
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 3,
        sx: {
          mt: 1.5,
          minWidth: 220,
          borderRadius: '8px'
        }
      }}
    >
      {items.map(item => (
        <MenuItem
          key={item.title}
          component={Link}
          to={item.path}
          onClick={onClose}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            py: 1,
            backgroundColor: isActive(item.path) ? theme.palette.action.selected : 'transparent',
            color: isActive(item.path) ? theme.palette.primary.main : 'inherit',
            '&:hover': {
              backgroundColor: theme.palette.action.hover
            }
          }}
        >
          <Icon name={item.iconName} fontSize="small" />
          <Typography variant="body2">{item.title}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default NavigationMenu;
